import * as React from "react";
import Loader from "./Loader";

class Description extends React.Component {

	render() {
		const loading = {
			height: '200px',
			display: 'flex',
			alignContent: 'center',
			justifyContent: 'center',
			alignItems: 'center'
		};


		const description = this.props.initialized ? (
			<span>
				<p className="emph">Order Information</p>
				<div className="row">
					<div className="col-sm-12">
						<p>
							<strong>Product:</strong>
							<span> {this.props.product.name}</span><br/>
							<strong>Description:</strong><span> {this.props.product.description}</span>
						</p>
						<p>
							<strong>Price:</strong><span> ${this.props.product.price}</span>
						</p>
					</div>
				</div>
			</span>
		) : (
			<div style={loading}>
				<Loader/>
			</div>
		);

		return (
			<form action="">
				<div className="form-box">
					{description}
				</div>
			</form>

		)
	}
}

export default Description;


// WEBPACK FOOTER //
// ./src/components/Description.jsx